import { ChangeDetectionStrategy, Component, computed, DestroyRef, HostBinding, OnInit, signal, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import {
  ApplicationService,
  AssistantService,
} from "../../../core-ui/services";
import { slideFromRight } from "../../../core-ui/core-ui.animations";
import { VisionService } from "../../../core-ui/services/vision.service";
import { ISnapshot, SnapshotService } from "@auvious/snapshot";

@Component({
  selector: "av-ai-assistant",
  templateUrl: "./ai-assistant.component.html",
  styleUrls: ["./ai-assistant.component.scss"],
  animations: [slideFromRight],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AIAssistantComponent implements OnInit {
  private assistant = inject(AssistantService);
  private vision = inject(VisionService);
  private application = inject(ApplicationService);
  private destroyRef = inject(DestroyRef);

  isAssistantOpen = signal(false);

  snapshots = signal<ISnapshot[]>([]);

  @HostBinding("class") get class() {
    return {
      "assistant-talkdesk": this.application.isTalkdeskApp,
    };
  }

  ngOnInit(): void {
    this.vision.imageChange$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((i) =>
      this.snapshots.update((s) => s.map((m) => (m.id === i.id ? i : m)))
    );
    this.vision.imagesAvailable$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((s) => this.snapshots.set(s));
    this.assistant.openChange$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((o) => this.isAssistantOpen.set(o));
  }

  dismiss() {
    this.assistant.toggleOpen(false);
  }

  trackByFn(index: number, el: ISnapshot) {
    return el.id;
  }
}
